import type { ExportColumn } from "../../common/interfaces/exportData";
import type { SalesOrder } from "../types/salesOrder";
import type { PurchaseOrder } from "../types/purchaseOrder";
import { FALLBACK_CURRENCY_CODE } from "../../../constants/currency";

export const exportSalesOrderColumns: ExportColumn<SalesOrder>[] = [
  { key: "documentNumber", label: "Order Number" },
  { key: "customerName", label: "Customer" },
  { key: "status", label: "Status" },
  {
    key: "totalAmount",
    label: "Total Amount",
    formatter: (value, row) => {
      const currency = row.currency || FALLBACK_CURRENCY_CODE;
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency
      }).format(value);
    }
  },
  { key: "currency", label: "Currency" },
  {
    key: "expectedDeliveryDate",
    label: "Expected Delivery",
    formatter: (value) => (value ? new Date(value).toLocaleDateString() : "N/A")
  },
  {
    key: "createdAt",
    label: "Created Date",
    formatter: (value) => new Date(value).toLocaleDateString()
  },
  {
    key: "updatedAt",
    label: "Last Updated",
    formatter: (value) => new Date(value).toLocaleDateString()
  }
];

export const exportPurchaseOrderColumns: ExportColumn<PurchaseOrder>[] = [
  { key: "documentNumber", label: "Order Number" },
  { key: "supplierName", label: "Supplier" },
  { key: "status", label: "Status" },
  {
    key: "totalAmount",
    label: "Total Amount",
    formatter: (value, row) => {
      const currency = row.currency || FALLBACK_CURRENCY_CODE;
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency
      }).format(value);
    }
  },
  { key: "currency", label: "Currency" },
  {
    key: "expectedDeliveryDate",
    label: "Expected Delivery",
    formatter: (value) => (value ? new Date(value).toLocaleDateString() : "N/A")
  },
  {
    key: "createdAt",
    label: "Created Date",
    formatter: (value) => new Date(value).toLocaleDateString()
  },
  {
    key: "updatedAt",
    label: "Last Updated",
    formatter: (value) => new Date(value).toLocaleDateString()
  }
];
